import { CopyBlockquote } from '@sleepstation/components-copy'
import { useScrollToReveal } from '@sleepstation/components-hooks'
import { VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { parseToAst } from '@sleepstation/markdown'
import { mq, stylesIfPropTrue } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'
import {
  formatContext,
  formatFirstName,
} from '../../../../helpers/formatting/testimonial'
import AvatarHeader from '../../AvatarHeader'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const MAPPING = {
  // eslint-disable-next-line react/display-name, react/prop-types
  blockquote: ({ children }) => <CopyBlockquote>{children}</CopyBlockquote>,
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [LAYOUT_SPACING.MEDIUM],
})`
  ${mq(`xSmallOnly`)} {
    background: transparent;
  }

  opacity: 0;
  transition: opacity 0.5s ease-in-out;

  ${stylesIfPropTrue(
    `isRevealed`,
    css`
      opacity: 1;
    `
  )}
`

const Body = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  align: LAYOUT_ALIGN.LEFT,
})`
  strong {
    color: #25904e;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TestimonialSimple = ({ testimonial, size, toTitle, toSubtitle }) => {
  const { avatarImage, quote } = testimonial

  const title = toTitle(testimonial)
  const subtitle = toSubtitle(testimonial)
  const htmlAst = parseToAst(`> ${quote}`)
  const ref = React.useRef()
  const isRevealed = useScrollToReveal(ref)

  return (
    <Layout ref={ref} isRevealed={isRevealed}>
      <AvatarHeader
        title={title}
        size={size}
        subtitle={subtitle}
        image={avatarImage}
      />
      <Body>
        <CopyRenderer mapping={MAPPING} htmlAst={htmlAst} />
      </Body>
    </Layout>
  )
}

TestimonialSimple.propTypes = {
  testimonial: PropTypes.object.isRequired,
  toTitle: PropTypes.func,
  toSubtitle: PropTypes.func,
  size: PropTypes.string,
}

TestimonialSimple.defaultProps = {
  toTitle: formatFirstName,
  toSubtitle: formatContext,
  size: undefined,
}

export default TestimonialSimple
